import { createFileRoute } from "@tanstack/react-router";
import { ReportsPage } from "@/components/dashboard/reports-page";
export const Route = createFileRoute("/reports")({
 head:()=>({meta:[{title:"Reports — Deuxda Admin"},{name:"description",content:"Review reports made from chat conversations."},{property:"og:title",content:"Reports — Deuxda Admin"},{property:"og:description",content:"Review reports made from chat conversations."},{property:"og:type",content:"website"},{name:"twitter:card",content:"summary_large_image"}]}),
 component:()=> <ReportsPage/>,
});
